import { useQueryClient } from '@tanstack/react-query'

import { FETCH_REFERRAL_SETUP_DATA_QUERY_OPTIONS } from '@/pages/referClient/constants'

export function usePrefetchReferralSetupQuery() {
  const queryClient = useQueryClient()

  return async function () {
    return queryClient.prefetchQuery(FETCH_REFERRAL_SETUP_DATA_QUERY_OPTIONS)
  }
}
